// extracted by mini-css-extract-plugin
export var divider = "_yq-0";